module.exports = __webpack_public_path__ + "static/media/heavy_pound33.f78f9a9c.jpg";